"use client"

import { createContext, type ReactNode, useContext } from "react"

import type { FooterInterface } from "~/components/elements/Footer/Footer.interface"

const FooterContext = createContext<FooterInterface | undefined>(undefined)

type ProviderProps = {
  data: FooterInterface
  children: ReactNode
}

export const FooterProvider = ({ data, children }: ProviderProps) => {
  return (
    <FooterContext.Provider value={data}>{children}</FooterContext.Provider>
  )
}

/** Hook to access the 'FooterProvider' context. */
export const useFooter = () => {
  const contextValue = useContext<FooterInterface | undefined>(FooterContext)

  if (!contextValue) {
    throw new Error(
      "'useFooter' must be used in a component with a parent 'FooterProvider'.",
    )
  }

  return contextValue
}
